var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.95L11.893 6 14 4.05v3.9zM10.25 9a.75.75 0 01-.75.75H2.75A.75.75 0 012 9V3a.75.75 0 01.75-.75H9.5a.75.75 0 01.75.75v6zm4.509-6.64a1.288 1.288 0 00-1.388.229l-1.621 1.5V3c0-1.24-1.01-2.25-2.25-2.25H2.75C1.51.75.5 1.76.5 3v6c0 1.241 1.01 2.25 2.25 2.25H9.5c1.24 0 2.25-1.009 2.25-2.25V7.912l1.62 1.499a1.293 1.293 0 001.388.23c.458-.2.742-.626.742-1.113V3.472c0-.486-.284-.913-.741-1.112z",
    fill: "#C4C4C4"
  })));
}

export default SvgVideo;